/**
 * Price component
 *
 * @module price-component
 * @version 1.0.0
 * @extends HTMLElement
 */
class priceComponent extends HTMLElement {
  /**
   * Product price web component.
   *
   * @constructor
   */
  constructor() {
    super();

    this.initEvents();
  }

  /**
   * Init events.
   *
   * @returns {undefined}
   */
  initEvents() {
    // On variant change
    window.addEventListener('variant-change', this.onVariantChange.bind(this));
  }

  /**
   * On variant change.
   *
   * @param {object} event Event.
   * @returns {undefined}
   */
  onVariantChange(event) {
    if (event.detail.product.handle == this.dataset.handle) {

      let isQuickviewTrigger = event.detail.isQuickviewTrigger || false;

      if(isQuickviewTrigger){

        let isQuickviewPriceComponent = (typeof this.dataset.priceComponentQuickview != 'undefined') ? true : false;
        
        if(isQuickviewPriceComponent){
          this.update(event.detail.variant);
        }

      }else {
        this.update(event.detail.variant);
      }

    }
  }

  /**
   * Update price.
   *
   * @returns {undefined}
   */
  update(variant) {
    if (variant) {
      this.querySelector('[data-price]').innerHTML = window.theme.money.format(
        variant.price
      );

      let compareAtPrice = this.querySelector('[data-compareatprice]');
      let originalPrice = this.querySelector('[data-dtp-original-price]');

      if (compareAtPrice) {
        compareAtPrice.innerHTML = variant.compare_at_price
          ? window.theme.money.format(variant.compare_at_price)
          : '';
      }

      if ((variant.price < variant.compare_at_price && originalPrice) || (variant.price < variant.compare_at_price && originalPrice)) {

        if (!compareAtPrice && (variant.price < variant.compare_at_price && originalPrice)) {
          let jsProductPriceCompared = this.querySelector(".js-product-price--compared");

          if (jsProductPriceCompared) jsProductPriceCompared.remove();

          let compareAtPriceItem = document.createElement("span");
          compareAtPriceItem.className = "product-price--compared text-base text-disabled-dark ml-1 mb-2 inline-block line-through js-product-price--compared";
          compareAtPriceItem.innerHTML = `${window.theme.money.format(variant.compare_at_price)}`;

          originalPrice.parentNode.insertBefore(compareAtPriceItem, originalPrice.nextSibling);
        }
      } else {
        let compareAtPriceItem = this.querySelector(".product-price--compared.js-product-price--compared");

        if (compareAtPriceItem) {
          compareAtPriceItem.remove();
        }
      }
    }
  }
}

customElements.define('price-component', priceComponent);
